import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "animate-text"
};
const _hoisted_2 = {
  class: "text"
};
const _hoisted_3 = {
  key: 0,
  class: "cursor blink"
};
import { ref, watch } from 'vue';
import { typewriterEffect } from '@utils/window-helpers';
export default /*@__PURE__*/_defineComponent({
  __name: 'AnimateText',
  props: {
    text: {}
  },
  emits: ["start", "end"],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const showText = ref('');
    const show = ref(false);
    const typeWriter = text => {
      if (!text) {
        emits('end');
        return;
      }
      emits('start');
      showText.value = '';
      show.value = true;
      typewriterEffect(text, val => {
        showText.value += val;
      }, () => {
        emits('end');
        show.value = false;
      });
    };
    watch(() => props.text, newVal => {
      if (newVal) showText.value = newVal;
    }, {
      immediate: true
    });
    __expose({
      setText(txt) {
        showText.value = txt;
      },
      typeWriter
    });
    return (_ctx, _cache) => {
      return showText.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, _toDisplayString(showText.value), 1), show.value ? (_openBlock(), _createElementBlock("span", _hoisted_3, "|")) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "default")])) : _createCommentVNode("", true);
    };
  }
});